import React from "react";
import StorageStatus from "../StorageStatus";
import { ModalContainer, ModalHeader, ModalFooter } from "./DeleteFileModal.styled";
import TextView from "../../TextView";
import Button from "../../Button";
import RedCloud from "../../../assets/images/notification_red_storage.svg";
import CleanupIcon from "../../../assets/images/cleanup-mop.svg";

const DeleteFileModal = ({ onClose }) => {
    return (
        <ModalContainer>
            <ModalHeader>
                <TextView variant="title" style={{ textAlign: "center" }}>Are you sure you want to delete these files?</TextView>
            </ModalHeader>
            <div>
                <TextView variant="largeText" color="#6B6F80" style={{ textAlign: "center" }}>If any deleted media is part of a Wheel, it will no longer be accessible and may affect the display of the Wheel.</TextView>
            </div>
            <ModalFooter>
                <Button style={{ width: "auto", padding: "0 48px" }}>Yes</Button>
                <Button secondary onClick={onClose} style={{ width: "auto", padding: "0 12px" }}>Cancel</Button>
            </ModalFooter>
        </ModalContainer>
    );
};

export default DeleteFileModal;
